export enum PhotoEventType {
  EditPhoto,
  LoadPhoto,
  CancelEditPhoto,
  FileChanged,
  UndoPhotoChanges,
  PhotoCropped,
  ClearPhoto
}
